<app-reaction-details [activityId]="activityId"></app-reaction-details>
